import gql from 'graphql-tag';

export const queryForShiftTurnovers = gql`
  query queryForShiftTurnovers(
    $limit: Int
    $page: Int
    $query: ShiftTurnoverSortOrQuery
    $sort: ShiftTurnoverSortOrQuery
  ) {
    queryForShiftTurnovers(
      limit: $limit
      page: $page
      query: $query
      sort: $sort
    ) {
      items {
        id
        aor
        aorName
        status
        shiftDate
        shiftTypeId
        shiftName
        incomingFirstName
        incomingLastName
        secondIncomingFirstName
        secondIncomingLastName
        departingFirstName
        departingLastName
        businessUnits
      }
      totalRecords
    }
  }
`;
